// Carrier-picker grouping, shared by the landing (App) and finder pickers so
// both stay in lockstep.
//
// The picker deliberately shows ONLY carriers we can crawl (a shop adapter
// exists → `crawlable`). Every other carrier — the ones behind logins, bot
// walls, or with no public locator — is funnelled into the "Other" path, which
// shows all nearby shops with no per-carrier network view. Hiding them is
// honest: we'd have nothing carrier-specific to show anyway.
import type { Insurer } from "../shared/types";

// Non-carrier picker options (no insurer network to display).
export const SPECIAL_IDS = new Set(["uninsured", "other"]);

export const isSpecialInsurer = (id: string | null | undefined): boolean =>
  !!id && SPECIAL_IDS.has(id);

export interface PickerGroups {
  /** Carriers whose network we can ingest — shown as first-class options. */
  carriers: Insurer[];
  /** "Other / not listed" + "Uninsured" — the catch-all for everyone else. */
  special: Insurer[];
}

// Split the full insurer list into what the picker renders. Non-crawlable,
// non-special carriers are intentionally dropped: they route through "Other".
export function partitionForPicker(insurers: Insurer[]): PickerGroups {
  const carriers: Insurer[] = [];
  const special: Insurer[] = [];
  for (const i of insurers) {
    if (SPECIAL_IDS.has(i.id)) special.push(i);
    else if (i.crawlable) carriers.push(i);
  }
  return { carriers, special };
}
